import { render, staticRenderFns } from "./site-list-desktop.vue?vue&type=template&id=06c94364"
import script from "./site-list-desktop.vue?vue&type=script&lang=js"
export * from "./site-list-desktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports